export const SHOW_MODAL = 'zola/modal/SHOW_MODAL';
export const HIDE_MODAL = 'zola/modal/HIDE_MODAL';
export const FLIP_FORMAT_FLAG = 'zola/modal/FLIP_FORMAT_FLAG';
export const IS_BUSY = 'zola/modal/IS_BUSY';
export const SHOW_SECONDARY_MODAL = 'zola/modal/SHOW_SECONDARY_MODAL';
export const HIDE_SECONDARY_MODAL = 'zola/modal/HIDE_SECONDARY_MODAL';



/** WEBPACK FOOTER **
 ** ./src/actions/types/ModalActionTypes.js
 **/